























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ICheckMNOMaskResponse, IMNOMask, IMNOMaskCreate } from '@/interfaces';
import {
  dispatchAddMNOMask,
  dispatchDeleteMNOMasks,
  dispatchGetMNOMasks,
  readMNOMasks,
  dispatchGetMNO,
  readOneMNO,
  dispatchCheckMNOMask,
  readCheckMNOMaskResponse,
} from '@/store/admin/accessors';
import VTextFieldWithValidation from '@/components/VTextFieldWithValidation.vue';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    VTextFieldWithValidation,
  },
})
export default class MNOMasks extends Vue {
  public loading: boolean = false;
  public masks: IMNOMask[] = [];
  public total: number = 0;

  public selected: IMNOMask[] = [];
  public pagination: { sortBy; descending; page; rowsPerPage; footerProps } = {
    sortBy: 'id',
    descending: false,
    page: 1,
    rowsPerPage: 20,
    footerProps: { 'items-per-page-options': [10, 20, 50, 100] },
  };
  public headers = [
    {
      text: 'Mask',
      value: 'mask',
      align: 'left',
    },
    {
      text: 'Actions',
      value: 'id',
    },
  ];
  public id: number = 0;
  public mask: string = '';
  public maskOrPhone: string = '';
  public checkMaskResult: ICheckMNOMaskResponse | null = null;

  public dialog = false;
  public checkDialog = false;

  public valid = false;
  public $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
  };

  public updateMNOMasks() {
    this.loading = true;
    this.getDataFromApi().then((data) => {
      if (typeof data === 'number') {
        this.total = data;
        this.masks = readMNOMasks(this.$store);
      }
    });
    this.loading = false;
  }

  get mnoId() {
    return +this.$router.currentRoute.params.id;
  }

  get mno() {
    return readOneMNO(this.$store)(this.mnoId) || {};
  }

  public async mounted() {
    await dispatchGetMNO(this.$store, +this.$router.currentRoute.params.id);
    this.updateMNOMasks();
  }

  public async deleteMNOMask(id: number) {
    if (confirm('Are you sure you want to delete this receiver?')) {
      await dispatchDeleteMNOMasks(this.$store, { mnoId: this.mnoId, ids: [id] });
      this.updateMNOMasks();
    }
  }
  public async deleteMNOMasks() {
    if (confirm('Are you sure you want to delete selected receivers?')) {
      const selected = this.selected.map((item) => item.id as number);
      await dispatchDeleteMNOMasks(this.$store, { mnoId: this.mnoId, ids: selected });
      this.selected = [];
      this.updateMNOMasks();
    }
  }

  public async getDataFromApi() {
    const { sortBy, descending, page, rowsPerPage } = this.pagination;
    const skip = (page - 1) * rowsPerPage;
    return await dispatchGetMNOMasks(this.$store, {
      skip,
      limit: rowsPerPage,
      mnoId: this.mnoId,
    });
  }

  public dialogClose() {
    this.id = 0;
    this.mask = '';
    this.dialog = false;
    this.$refs.observer.reset();
  }

  public checkDialogClose() {
    this.maskOrPhone = '';
    this.checkMaskResult = null;
    this.checkDialog = false;
  }

  public async submit() {
    if (await this.$refs.observer.validate()) {
      const payload: IMNOMaskCreate = {
        mask: this.mask,
      };
      const result = await dispatchAddMNOMask(this.$store, { mnoId: this.mnoId, data: payload });
      if (result) {
        this.updateMNOMasks();
        this.dialog = false;
      }
    }
  }

  public async submitCheckMask() {
    await dispatchCheckMNOMask(this.$store, this.maskOrPhone);
    this.checkMaskResult = readCheckMNOMaskResponse(this.$store);
  }

  @Watch('dialog')
  public onDialogChange(val) {
    return val || this.dialogClose();
  }

  @Watch('checkDialog')
  public onCheckDialogChange(val) {
    return val || this.checkDialogClose();
  }

  @Watch('pagination', { deep: true })
  public onPaginationChange(val) {
    this.updateMNOMasks();
  }
}
